import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * SPDX-FileCopyrightText: 2024 Genome Research Ltd.
 *
 * SPDX-License-Identifier: MIT
 */
import { useState } from "react";
import DropdownButtons from "../../general/DropdownButtons";
import NewBoardModal from "./NewBoardModal";
import { useHistory } from "react-router-dom";
import { createBoardAndView } from "../utils";
import { TsDataSource } from "../../index";
const DEFAULT_TITLE = "My Boards";
const DEFAULT_SUB_TITLE = "Here you can view and delete your boards, along with viewing board hierarchy and components of each zone.";
function MyBoardsHeader(props) {
    const [newBoardModalOpen, setNewBoardModalOpen] = useState(false);
    const [modalError, setModalError] = useState("");
    const history = useHistory();
    const ds = new TsDataSource();
    const defaultDropdownButtons = [
        {
            name: "Create New Board",
            action: () => handleOpenModal(),
        },
    ];
    const handleNewBoardCreate = async (boardId, viewId, boardTitle, viewTitle) => {
        try {
            createBoardAndView(ds, boardId, boardTitle, viewId, viewTitle);
        }
        catch {
            setModalError("Failed to create board, please try again.");
        }
        finally {
            if (modalError === "") {
                setTimeout(() => {
                    history.push(`/board/${boardId}`);
                }, 800);
            }
        }
    };
    const handleOpenModal = () => {
        setNewBoardModalOpen(true);
    };
    const newBoardModal = () => (_jsx(NewBoardModal, { setOpen: setNewBoardModalOpen, open: newBoardModalOpen, onConfirmClick: (boardId, viewId, boardTitle, viewTitle) => handleNewBoardCreate(boardId, viewId, boardTitle, viewTitle) }));
    const defaultDropdownMainIcon = {
        icon: "plus",
        type: "success",
        tooltip: "Create Board",
    };
    const { title = DEFAULT_TITLE, subTitle = DEFAULT_SUB_TITLE, containerStyle, menuStyle = { marginRight: "10px" }, dropdownButtons = defaultDropdownButtons, dropdownMainIcon = defaultDropdownMainIcon, disabled = false, placement = "leftStart", customClass = "", } = props;
    return (_jsxs("div", { style: containerStyle, className: customClass, children: [_jsxs("div", { children: [_jsx("h1", { children: title }), _jsx("p", { children: subTitle })] }), _jsx("div", { style: newBoardModalOpen ? { display: "none" } : {}, children: _jsx(DropdownButtons, { mainButtonIcon: dropdownMainIcon, placement: placement, disabled: disabled, dropdownButtons: dropdownButtons, menuStyle: menuStyle, showMessages: false }) }), newBoardModalOpen && newBoardModal()] }));
}
export default MyBoardsHeader;
